import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className="footer-section section section-pad-md light bg-footer has-bg-image" >
            <div className="imagebg footerbg bg-image-loaded" style={{ backgroundImage: `url(${require('../../assets/images/footer-bg.png')})` }}>
                <img src={require("../../assets/images/footer-bg.png")} alt="footer-bg" />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-sm-6 wgs-box res-m-bttm">
                        <div className="wgs-footer wgs-menu text-left">
                            <h5 className="wgs-title ucap">Company</h5>
                            <div className="wgs-content">
                                <ul className="menu">
                                    <li><Link to="/about">About Us</Link></li>
                                    <li><Link to="/account-types">Account Types</Link></li>
                                    <li><Link to="/forex">Forex</Link></li>
                                    <li><Link to="/shares">Shares</Link></li>
                                    <li><Link to="/bonds">Bonds</Link></li>
                                    <li><Link to="/digital-currencies">Digital Currencies</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 wgs-box res-m-bttm">
                        <div className="wgs-footer wgs-menu text-left">
                            <h5 className="wgs-title ucap">Support</h5>
                            <div className="wgs-content">
                                <ul className="menu">
                                    <li><Link to="/contact">Contact Us</Link></li>
                                    <li><Link to="/faqs">FAQ</Link></li>
                                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                    <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 wgs-box res-m-bttm">
                        <div className="wgs-footer wgs-contact text-left">
                            <h5 className="wgs-title ucap">get in touch</h5>
                            <div className="wgs-content">
                                <ul className="wgs-contact-list">
                                    <li><span className="pe pe-7s-map-marker"></span>20 Fenchurch St, City of London,<br />London EC3M 3BY, United Kingdom</li>
                                    <li><span className="pe pe-7s-call"></span>Telephone : (123) 4567 8910 <br />Telephone : (123) 1234 5678</li>
                                    {/* <li><span className="pe pe-7s-global"></span>Email : <a href="mailto:info@sitename.com">info@sitename.com</a> <br />Web : <a href="http://example.com">www.example.com</a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
